// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/views/admin.admin.form.scss
// module id = 16
// module chunks = 0